import React, { useState } from "react"
import "./header.css"
import logo from "../pic/logo.png"
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import GitHubIcon from '@mui/icons-material/GitHub';

const Header = () => {
  // fixed Header
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header")
    header.classList.toggle("active", window.scrollY > 100)
  })
  // Toogle Menu
  const [Mobile, setMobile] = useState(false)
  return (
    <>
      <header className='header'>
        <div className='container d_flex'>
          <div className='logo'>
            {/* <img src={logo} alt='' /> */}
            <ul className="left_nav">
              <li> <a href="https://www.facebook.com/profile.php?id=100054789188742"> <FacebookOutlinedIcon /> </a> </li>
              <li> <a href="https://www.instagram.com/01werka/"> <InstagramIcon /> </a> </li>
              <li> <a href="https://t.me/werka01"> <TelegramIcon /> </a> </li>
              <li> <a href="https://github.com/01werka"> <GitHubIcon /> </a> </li>
              <li> <a href="https://www.linkedin.com/in/sherzod-tashpolatov-b3baa922a/"> <LinkedInIcon /> </a> </li>
            </ul>
          </div>

          <div className='navlink'>
            <ul className={Mobile ? "nav-links-mobile" : "link f_flex uppercase"} onClick={() => setMobile(false)}>
              {/*<ul className='link f_flex uppercase {Mobile ? "nav-links-mobile" : "nav-links"} onClick={() => setMobile(false)}'>*/}
              <li>
                <a href='#home'>home</a>
              </li>
              {/* <li>
                <a href='#features'>features</a>
              </li> */}
              <li>
                <a href='#portfolio'>portfolio</a>
              </li>
              <li>
                <a href='#resume'>resume</a>
              </li>
              <li>
                <a href='#information'>Informations</a>
              </li>
              {/* <li>
                <a href='#blog'>blog</a>
              </li> */}
              <li>
                <a href='#contact'>contact</a>
              </li>
              <li>
                <a href="https://www.instagram.com/01werka/" target="_blank">
                  <button className='home-btn'>01werka</button>
                </a>
              </li>
            </ul>
           

            <button className='toggle' onClick={() => setMobile(!Mobile)}>
              {Mobile ? <i className='fas fa-times close home-btn'></i> : <i className='fas fa-bars open'></i>}
            </button>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
